import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import type { RootState } from '../../../configuration/setup/store';
import { getContactData } from '../formElements/redux/formElements.redux';

interface Props {
    showTitle: boolean;
}

const ContactFormHeader = ({ showTitle }: Props) =>
    showTitle ? (
        <div className='text-center'>
            <h1 className='margin-top-0 margin-bottom-2pct'>
                <FormattedMessage id={'intl-msg:contactForm.contactButtonText'} />
            </h1>
        </div>
    ) : null;

const mapStateToProps = (state: RootState) => ({
    showTitle: !getContactData(state).hideTitle,
});

export const ContactFormHeaderContainer = connect(mapStateToProps)(ContactFormHeader);
